// const Url = 'http://115.124.96.40:9041'
//const Url = 'http://192.168.0.245:9045'
const Url = process.env.REACT_APP_API_URL
const AccessKeyId = process.env.REACT_APP_ACCESS_KEY_ID
const SecretAccessKey= process.env.REACT_APP_SECREATE_ACCESS_KEY
const Region= process.env.REACT_APP_REGION
const enckey= process.env.REACT_APP_ENC_KEY
export { Url,AccessKeyId,SecretAccessKey,Region,enckey}